// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hafZ","col":"styles_col__33NzG","actions":"styles_actions__3MBWR","conflict":"styles_conflict__2Wz_N"};